import { Component, OnInit, ViewChild } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { CurrentUserStateService } from '@app/services/currentUserState.service';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';

@Component({
    selector: 'app-settings-menu',
    templateUrl: './settings-menu.component.html',
    styleUrls: ['./settings-menu.component.scss'],
})
export class SettingsMenuComponent implements OnInit {
    @ViewChild('menu') menu?: Menu;

    displayCustomInstructions: boolean = false;
    displayPromptLibrary: boolean = false;
    showUsageStats: boolean = false;

    menuItems: MenuItem[] = [];

    private buildMenuItems(isAdmin: boolean): MenuItem[] {
        let menuItems: MenuItem[] = [
            { label: 'Custom Instructions', command: () => this.openCustomInstructionsDialog() },
        ];
        if (isAdmin) {
            menuItems = menuItems.concat([
                { separator: true },
                { label: 'Prompt Library', command: () => this.openPromptLibraryDialog() },
                { label: 'Usage Statistics', command: () => this.toggleUsageStats(true) },
            ]);
        }
        return menuItems.concat([
            { separator: true },
            { label: 'Log out', command: () => this.onLogoutButtonClick() }
        ]);
    }

    constructor(
        private readonly authService: MsalService,
        protected currentUserStateService: CurrentUserStateService
    ) { }

    ngOnInit() {
        this.currentUserStateService.value$.subscribe(_ => {
            const isAdmin = this.currentUserStateService.hasRole('GlobalAdmin');
            this.menuItems = this.buildMenuItems(isAdmin);
        });
    }

    showMenu(ev: Event) {
        this.menu?.toggle(ev);
    }

    public onLogoutButtonClick() {
        console.log('Settings menu logging out user');
        return this.authService.logoutRedirect({
            postLogoutRedirectUri: globalThis.location.origin,
        });
    }

    openCustomInstructionsDialog() {
        this.displayCustomInstructions = true;
    }

    submitInstructions(event: any) {
        this.displayCustomInstructions = false;
    }

    closeDialog(value: boolean) {
        this.displayCustomInstructions = false;
    }

    openPromptLibraryDialog() {
        this.displayPromptLibrary = true;
    }

    closePromptLibraryDialog(value: boolean) {
        this.displayPromptLibrary = false;
    }

    toggleUsageStats(value: boolean) {
        this.showUsageStats = value;
    }
}
